var viewer_rtlignore_default = {
  "gallery_container": "mIL-6",
  "imageTitleContainer": "p82By",
  "clickableItem": "PMik-",
  "prerender": "_-9wJT",
  "expandContainer": "Td-NB",
  "expandIcon": "_8XMi4",
  "itemOverlay": "-jqFO",
  "imageTitle": "TRQJW",
  "pointer": "HhwKz",
  "fadeIn": "QKuia",
  "changing_background": "oSPe3"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
